export default __webpack_public_path__ + "static/img4_final-f0b1241583b824e34959687f4d36576f.png";